var exports = {
  "i": "x24da60e8--2e629f--wrapper",
};

module.exports = exports;
